<template>
    <div class="lunch">
    </div>
</template>
<script>
export default {
    name: 'Lunch'
}
</script>
<style>
.lunch{
    background: url('../assets/lunch.png');
    min-height: calc(100vh);
    background-size: 100% 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/Lunch.vue